var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.01783 21.43H13.1125C13.1759 21.43 13.2402 21.421 13.3036 21.4129C13.4076 21.42 13.5106 21.43 13.6166 21.43C16.1196 21.43 18.1554 19.2663 18.1554 16.6084C18.1554 15.7214 17.9247 14.8937 17.5304 14.1785L17.8614 14.2649C17.902 14.276 17.9417 14.28 17.9824 14.28C18.1148 14.28 18.2434 14.2247 18.3389 14.1233L19.8519 12.5161C19.9805 12.3795 20.0306 12.1796 19.9814 11.9937C19.9322 11.8069 19.7932 11.6632 19.6164 11.6171L18.5715 11.3428L18.3124 10.2329C18.2689 10.045 18.1337 9.89736 17.9588 9.84513C17.7829 9.7939 17.5957 9.84614 17.4661 9.98275L15.9532 11.5899C15.8283 11.7225 15.7773 11.9154 15.8198 12.0972L15.9012 12.4478C15.6562 12.2961 15.3981 12.1676 15.1277 12.0661V4.82057C15.1277 3.63827 14.2227 2.67798 13.1107 2.67798H11.5977V2.14259C11.5977 1.84728 11.3727 1.6072 11.0937 1.6072H9.51743C9.29333 0.684076 8.50186 0 7.56383 0C6.62485 0 5.83528 0.684076 5.61022 1.6072H4.03391C3.75592 1.6072 3.52992 1.84728 3.52992 2.14259V2.67798H2.01696C0.903975 2.67798 0 3.63929 0 4.82057V19.2854C0 20.4677 0.904943 21.428 2.01696 21.428L2.01783 21.43ZM13.6165 20.3582C11.6705 20.3582 10.0866 18.6756 10.0866 16.6084C10.0866 14.5401 11.6705 12.8586 13.6165 12.8586C14.408 12.8586 15.1371 13.1409 15.7262 13.61L15.0047 14.3764C14.6056 14.0962 14.129 13.9304 13.6165 13.9304C12.2265 13.9304 11.0946 15.1318 11.0946 16.6094C11.0946 18.086 12.2255 19.2884 13.6165 19.2884C15.0066 19.2884 16.1384 18.087 16.1384 16.6094C16.1384 16.065 15.9824 15.5587 15.7186 15.1348L16.4401 14.3684C16.8817 14.9942 17.1474 15.7696 17.1474 16.6094C17.1474 18.6777 15.5635 20.3592 13.6175 20.3592L13.6165 20.3582ZM15.1295 16.6084C15.1295 17.4944 14.4506 18.2156 13.6165 18.2156C12.7825 18.2156 12.1036 17.4944 12.1036 16.6084C12.1036 15.7224 12.7825 15.0012 13.6165 15.0012C13.8492 15.0012 14.0676 15.0615 14.2643 15.1629L13.2601 16.2297C13.0624 16.4396 13.0624 16.7781 13.2601 16.9871C13.3584 17.0916 13.488 17.1438 13.6166 17.1438C13.7461 17.1438 13.8747 17.0916 13.9731 16.9871L14.9773 15.9203C15.0718 16.1303 15.1295 16.3613 15.1295 16.6084ZM17.5493 11.4132L17.6656 11.9154C17.71 12.1083 17.8519 12.2589 18.0334 12.3061L18.5062 12.4307L17.8263 13.1529L17.0585 12.951L16.8684 12.1354L17.5483 11.4131L17.5493 11.4132ZM4.53881 2.67898H6.05177C6.32977 2.67898 6.55577 2.43891 6.55577 2.14359C6.55577 1.55294 7.00777 1.07178 7.56473 1.07178C8.12075 1.07178 8.57369 1.55194 8.57369 2.14359C8.57369 2.4389 8.79969 2.67898 9.07769 2.67898H10.5906V3.75079H4.53881V2.67898ZM1.00889 4.82157C1.00889 4.23092 1.46089 3.74976 2.01786 3.74976H3.53082V4.28515C3.53082 4.58047 3.75681 4.82054 4.03481 4.82054H11.0956C11.3746 4.82054 11.5996 4.58047 11.5996 4.28515V3.74976H13.1126C13.6686 3.74976 14.1215 4.22992 14.1215 4.82157V11.8179C13.9561 11.7978 13.7877 11.7868 13.6175 11.7868C12.2776 11.7868 11.0758 12.4106 10.2445 13.394H6.5577C6.27971 13.394 6.05371 13.634 6.05371 13.9294C6.05371 14.2247 6.2797 14.4648 6.5577 14.4648H9.5582C9.25467 15.1116 9.07878 15.8369 9.07878 16.6073H6.55685C6.27886 16.6073 6.05286 16.8474 6.05286 17.1427C6.05286 17.4381 6.27886 17.6781 6.55685 17.6781H9.19497C9.4257 18.7499 9.99118 19.6881 10.7703 20.3571L2.01793 20.3581C1.46191 20.3581 1.00897 19.878 1.00897 19.2863L1.00889 4.82157Z",
    fill: "url(#paint0_linear_3283_16150)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.55673 8.03611H12.6086C12.8875 8.03611 13.1126 7.79604 13.1126 7.50072C13.1126 7.20541 12.8875 6.96533 12.6086 6.96533H6.55673C6.27873 6.96533 6.05273 7.20541 6.05273 7.50072C6.05273 7.79604 6.27873 8.03611 6.55673 8.03611Z",
    fill: "url(#paint1_linear_3283_16150)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.55673 11.2505H12.6086C12.8875 11.2505 13.1126 11.0104 13.1126 10.7151C13.1126 10.4198 12.8875 10.1797 12.6086 10.1797H6.55673C6.27873 10.1797 6.05273 10.4198 6.05273 10.7151C6.05273 11.0104 6.27873 11.2505 6.55673 11.2505Z",
    fill: "url(#paint2_linear_3283_16150)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.8329 8.77745C2.93124 8.88192 3.06079 8.93415 3.1894 8.93415C3.31895 8.93415 3.44754 8.88192 3.5459 8.77745L4.91134 7.32696C5.10897 7.11701 5.10897 6.7785 4.91134 6.56957C4.71371 6.35962 4.39504 6.35962 4.19836 6.56957L3.1894 7.64138L2.86316 7.29481C2.66552 7.08487 2.34686 7.08487 2.15018 7.29481C1.95255 7.50475 1.95255 7.84327 2.15018 8.0522L2.8329 8.77745Z",
    fill: "url(#paint3_linear_3283_16150)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M2.8329 11.9918C2.93124 12.0963 3.06079 12.1485 3.1894 12.1485C3.31895 12.1485 3.44754 12.0963 3.5459 11.9918L4.91134 10.5413C5.10897 10.3314 5.10897 9.99286 4.91134 9.78392C4.71371 9.57398 4.39504 9.57398 4.19836 9.78392L3.1894 10.8557L2.86316 10.5092C2.66552 10.2992 2.34686 10.2992 2.15018 10.5092C1.95255 10.7191 1.95255 11.0576 2.15018 11.2666L2.8329 11.9918Z",
    fill: "url(#paint4_linear_3283_16150)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.8329 15.2062C2.93124 15.3106 3.06079 15.3629 3.1894 15.3629C3.31895 15.3629 3.44754 15.3106 3.5459 15.2062L4.91134 13.7557C5.10897 13.5457 5.10897 13.2072 4.91134 12.9983C4.71371 12.7883 4.39504 12.7883 4.19836 12.9983L3.1894 14.0701L2.86316 13.7235C2.66552 13.5136 2.34686 13.5136 2.15018 13.7235C1.95255 13.9335 1.95255 14.272 2.15018 14.4809L2.8329 15.2062Z",
    fill: "url(#paint5_linear_3283_16150)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M2.8329 18.4205C2.93124 18.525 3.06079 18.5772 3.1894 18.5772C3.31895 18.5772 3.44754 18.525 3.5459 18.4205L4.91134 16.97C5.10897 16.7601 5.10897 16.4216 4.91134 16.2126C4.71371 16.0027 4.39504 16.0027 4.19836 16.2126L3.1894 17.2844L2.86316 16.9379C2.66552 16.7279 2.34686 16.7279 2.15018 16.9379C1.95255 17.1478 1.95255 17.4863 2.15018 17.6953L2.8329 18.4205Z",
    fill: "url(#paint6_linear_3283_16150)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3283_16150",
    x1: 10.4408,
    y1: 22.1437,
    x2: 3.16137,
    y2: 15.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9DB",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976D2",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3283_16150",
    x1: 9.73826,
    y1: 8.07177,
    x2: 9.62668,
    y2: 7.35815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9DB",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976D2",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3283_16150",
    x1: 9.73826,
    y1: 11.2861,
    x2: 9.62668,
    y2: 10.5725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9DB",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976D2",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3283_16150",
    x1: 3.59815,
    y1: 9.01814,
    x2: 2.74839,
    y2: 8.01886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9DB",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976D2",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3283_16150",
    x1: 3.59815,
    y1: 12.2325,
    x2: 2.74839,
    y2: 11.2332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9DB",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976D2",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3283_16150",
    x1: 3.59815,
    y1: 15.4469,
    x2: 2.74839,
    y2: 14.4476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9DB",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976D2",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3283_16150",
    x1: 3.59815,
    y1: 18.6612,
    x2: 2.74839,
    y2: 17.6619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9DB",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976D2",
    stopOpacity: 0.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoals);
export default __webpack_public_path__ + "static/media/goals.1b56500d8dba03dc7724a69bcdb335a8.svg";
export { ForwardRef as ReactComponent };